import React from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined} from '@ant-design/icons';
import { CompanyGroup as CompanyGroupResponse } from '@/DTOS/CompanyGroup/Response/CompanyGroup';

export const CompanyGroupColumn = (
  handleEdit: (record: CompanyGroupResponse) => void
) => [
 
  {
    title: 'Agent Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    render: (record: boolean) => (record ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: any) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed:'right'
  },
];
